module.exports = __webpack_public_path__ + "media/images/lp/industries/solution-05-de9d58a90dff732543463ab0e897e929.png";